export const labelRegex = /{{(.*?)}}/g;

// Task Custom Attribute placeholders are identified by their value token, not by their group label:
// the token format is the contract rule-service validates and hagmonia resolves against.
const CUSTOM_ATTRIBUTE_VALUE_TYPE_REGEX = /^custom_attributes\.\d+$/;

export const isCustomAttributeToken = (type: string): boolean => CUSTOM_ATTRIBUTE_VALUE_TYPE_REGEX.test(type);

export const isCustomAttributeGroup = (label: { values?: { type: string }[] }): boolean =>
	!!label.values?.length && label.values.every(({ type }) => isCustomAttributeToken(type));

// Collects the Custom Attribute tokens (`custom_attributes.<id>`) used in the given contents.
export const getCustomAttributeTokens = (contents: string[]): Set<string> => {
	const tokens = new Set<string>();

	contents.forEach(content => {
		for (const match of (content ?? '').matchAll(labelRegex)) {
			if (isCustomAttributeToken(match[1])) {
				tokens.add(match[1]);
			}
		}
	});

	return tokens;
};
const ZWSP = '\u200b';

const matchText = str => str.matchAll(labelRegex);

export const findMismatchLabels = (str: string, labels: Set<string>): string[] => {
	const mismatch = [];
	if (!str) {
		return mismatch;
	}

	const matches = matchText(str);
	for (const match of matches) {
		if (!labels.has(match[1])) {
			mismatch.push(match[1]);
		}
	}

	return mismatch;
};

export const getDisplayMismatch = mismatch => mismatch.map(match => `'{${ZWSP}{${match}}}'`);
